import React from "react";

const FooterLockButton = ({ onLock }) => {
  return (
    <button
      className="btn btn-link nav-link p-0"
      onClick={onLock}
      title="Lock Screen"
      style={{
        textDecoration: "none",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <iconify-icon
        className="footer-icon-strong"
        icon="solar:lock-keyhole-line-duotone"
        style={{
          fontSize: "18px",
          filter:
            "drop-shadow(0 0 0 currentColor) drop-shadow(0 0 0 currentColor)",
        }}
      />
    </button>
  );
};

export default FooterLockButton;
